import React from "react"
import classNames from "utils/classNames"

interface AnalyticsCardGridProps {
  children?: React.ReactNode
}
const AnalyticsCardGrid = ({ children }: AnalyticsCardGridProps) => {
  return <div className={classNames("vt-analytics-card-grid")}>{children}</div>
}

export default AnalyticsCardGrid
